import { registerLocaleData } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ApplicationConfig, ErrorHandler, importProvidersFrom, inject, LOCALE_ID, provideAppInitializer, provideZonelessChangeDetection } from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import * as Sentry from "@sentry/angular";

import localeDe from '@angular/common/locales/de';
import localeDeCH from '@angular/common/locales/de-CH';

import { de_CH } from '@assets/i18n/de_CH';
import { en_US } from '@assets/i18n/en_US';
import { environment } from '@env/environment';
import { Observable, of } from "rxjs";

const TRANSLATION_MAP: Record<string, any> = {
  'de_CH': de_CH,
  'en_US': en_US,
};

// required for currency and date pipe
registerLocaleData(localeDe, 'de');
registerLocaleData(localeDeCH, 'ch');

export class CustomTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    return of(TRANSLATION_MAP[lang] ?? TRANSLATION_MAP[environment.defaultLocale]);
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: CustomTranslateLoader,
        },
      }),
    ),
    provideAnimations(),
    provideZonelessChangeDetection(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: LOCALE_ID, useValue: environment.defaultLocale.replace('_', '-').toLowerCase() },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false, }) },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
  ],
}